// extracted by mini-css-extract-plugin
module.exports = {"content":"src-components-common-TaxAuthProtocol-protocol-InstallProtocol-__index__content--2XBwL"};